<template>
  <div class="row">
    <div class="course-content-editor-container  small-12 columns">
      <div
        class="close-button absolute cursor-pointer"
        title="Close (Esc)"
        @click="$emit('CLOSE_MODAL')"
      >
        ❌
      </div>
      <div class="small-12 columns">
        <div><h2>Topic Editing</h2></div>
        <div class="small-3 columns">Name</div>
        <div class="small-9 columns">
          <input
            v-model="topic.name"
            class="input-box-course-creators"
            type="text"
          />
        </div>
        <div class="small-12 columns">
          <div class="small-3 columns">is Required</div>
          <div class="small-9 columns">
            <input v-model="topic.is_required" type="checkbox" />
          </div>
        </div>
        <div class="small-12 columns">
          <div class="row">
            <div class="small-3 columns">is bonus</div>
            <div class="small-9 columns">
              <input v-model="topic.is_bonus" type="checkbox" />
            </div>
          </div>
        </div>
        <div class="small-12 columns">
          <div class="row">
            <div class="small-3 columns">Available on</div>
            <div class="small-9 columns">
              <EdystDatePicker
                v-model="topic.available_on"
                :selected="
                  topic && topic.available_on
                    ? new Date(topic.available_on)
                    : null
                "
                placeholderText="Select available on date"
              />
            </div>
          </div>
        </div>
        <div class="small-12 columns">
          <div class="small-3 columns">Is Dependent IDs</div>
          <div class="small-9 columns">
            <multiselect
              v-model="selected"
              :options="topics"
              label="name"
              :multiple="true"
              @remove="removeTag"
            />
          </div>
        </div>
        <div class="small-12 columns">
          <button
            class="button-font button-green py-2 px-4 rounded-sm"
            style="margin-right:20px;"
            @click="editModule"
          >
            Save Topic
          </button>
          <button
            class="button-red button-font py-2 px-4 rounded-sm"
            @click="deleteTopic"
          >
            Delete Topic
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect"
import { mapGetters, mapActions } from "vuex"
import siteConfig from "@/utils/siteConfig"
import EdystDatePicker from "@/components/ReactDatePicker/DatePicker"

export default {
  components: { Multiselect, EdystDatePicker },
  props: ["topic", "topics"],
  data() {
    return {
      selected: [],
    }
  },
  computed: {
    ...mapGetters("module", ["getCurrentEditingTopic", "getCurrentModuleID"]),
  },
  created() {
    if (
      this.topic &&
      Object.prototype.hasOwnProperty.call(this.topic, "available_on")
    ) {
      this.topic.available_on = this.topic.available_on
    }
  },
  methods: {
    ...mapActions("module", ["LOAD_CURRENT_COURSES_EDITING_STATE"]),
    removeTag(tag) {
      let index
      for (let i = 0; i < this.selected.length; i++) {
        if (this.selected[i].id === tag.id) {
          index = i
        }
      }
      this.selected = this.selected.splice(index, 1)
    },
    editModule() {
      this.topic.is_dependent_ids = this.selected.map(item => item.id)

      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/topics/${this.topic.id}`,
        data: {
          name: this.topic.name,
          is_dependent_ids: this.topic.is_dependent_ids,
          is_bonus: this.topic.is_bonus,
          is_required: this.topic.is_required,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.topic.slug = res.data.slug

        if (this.topic.available_on) {
          const isoDate = new Date(this.topic.available_on).toISOString()
          this.topic.available_on = isoDate
        }

        this.$emit("TOPIC_UPDATED", this.topic)
      })
    },
    getSelectedTopics() {
      for (let i = 0; i < this.topics.length; i++) {
        for (let j = 0; j < this.topic.is_dependent_ids.length; j++) {
          if (this.topics[i].id === this.topic.is_dependent_ids[j]) {
            this.selected.push(this.topics[i])
          }
        }
      }
    },
    deleteTopic() {
      this.$emit("TOPIC_DELETE", this.topic.id)
    },
  },

  mounted() {
    this.getSelectedTopics()
  },
}
</script>

<style>
.button-font {
  font-size: 0.7em !important;
}

.course-content-editor-container > div > div {
  margin: 0.3rem 0;
}
</style>
